import Vuelidate from 'vuelidate'
import * as msg from '../../helpers/console'
import stickyBadge from '../../components/stickyBadge'

const init = () => {
  msg.success('HomeController', 'Ready!')

  new stickyBadge().init()

  Vue.component('mainform', require('../../vue/components/Form.vue').default)

  Vue.use(Vuelidate)

  window.app.vm = new Vue({
    el: '#app',
  })

}

export default init
